import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { translate } from 'react-admin';
import CardMedia from '@material-ui/core/CardMedia';
import {
    format,
    parseISO,
} from 'date-fns'

const style = theme => ({
    card: {
        flex: '1',
        maxHeight: 440,
    },
    list: {
        flex: '1',
        overflow: 'auto',
        maxHeight: 357,
    },
});

const DisconnectedResources = ({ terminals = [], total, translate, classes }) => (
    <Card className={classes.card}>
        <CardHeader title={translate('dashboard.disconnectedResources.title')} subheader={translate('dashboard.disconnectedResources.subheader') + `（${total ? total : 0}` + translate('dashboard.disconnectedResources.unit') + `）`} />
        <CardMedia className={classes.list}>
            <List>
                {terminals.map(record => (
                    <ListItem
                        button
                        to={`/terminals`}
                        component={Link}
                        key={record.id}
                    >
                        <ListItemText
                            primary={`${record.name}`}
                            secondary={`${translate('dashboard.disconnectedResources.lastAccessDateTime')} ${format(parseISO(record.lastAccessDateTime), "yyyy/MM/dd HH:mm:ss")}`}
                            className={classes.listItemText}
                        />
                    </ListItem>
                ))}
            </List>
        </CardMedia>
    </Card>
);

const enhance = compose(
    withStyles(style),
    translate
);

export default enhance(DisconnectedResources);